const state = {
  dialogs: {
    modal: true,
    closeOnEscape: false,
    dismissableMask: false,
  },
  layout: "web",
  showSidebar: false,
  errorToastMessage: "",
  sqlCode: "",
  graphs: [],
  triggerImpersonationUser: null,
  loadingUserGroups: false,
  closingSession: false,
};

export default state;
